import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';

export interface Element {
  position: number;
  selected: string;
  jobno: number;
  client: string;
  requestedDate: string;
  type: string;
  requestedPlacementDate: string;
  photo: string;
  class: string;
}

const ELEMENT_DATA: Element[] = [
  {
    position: 0,
    class: 'baseproject',
    selected: 'TRUE',
    jobno: 12345,
    client: 'ERA TOYE',
    requestedDate: '2025-11-15',
    type: 'Sleutel terugbrengen',
    requestedPlacementDate: '2025-11-15',
    photo: 'Not found',
  },
  {
    position: 1,
    class: 'adjustment',
    selected: 'TRUE',
    jobno: 12345,
    client: 'ERA TOYE',
    requestedDate: '2025-11-15',
    type: 'Sleutel terugbrengen',
    requestedPlacementDate: '2025-11-15',
    photo: 'Not found',
  },
  {
    position: 2,
    class: 'immo-task',
    selected: 'TRUE',
    jobno: 12345,
    client: 'ERA TOYE',
    requestedDate: '2025-11-15',
    type: 'Sleutel terugbrengen',
    requestedPlacementDate: '2025-11-15',
    photo: 'Not found',
  },
  {
    position: 3,
    class: 'repo',
    selected: 'TRUE',
    jobno: 12345,
    client: 'ERA TOYE',
    requestedDate: '2025-11-15',
    type: 'Sleutel terugbrengen',
    requestedPlacementDate: '2025-11-15',
    photo: 'Not found',
  },
  {
    position: 4,
    class: 'sold-rented',
    selected: 'TRUE',
    jobno: 12345,
    client: 'ERA TOYE',
    requestedDate: '2025-11-15',
    type: 'Sleutel terugbrengen',
    requestedPlacementDate: '2025-11-15',
    photo: 'Not found',
  },
];

@Component({
  selector: 'marker-multiselect-modal',
  templateUrl: 'marker-multiselect-modal.component.html',
  styleUrls: ['marker-multiselect-modal.component.scss'],
})
export class MarkerMultiselectModal {
  displayedColumns = [
    'selected',
    'jobno',
    'client',
    'requestedDate',
    'type',
    'requestedPlacementDate',
    'photo',
  ];
  dataSource = new MatTableDataSource<Element>(ELEMENT_DATA);
  selection = new SelectionModel<Element>(true, []);

  date = new FormControl(new Date());

  options = [
    { value: 'steak-0', viewValue: 'Steak' },
    { value: 'pizza-1', viewValue: 'Pizza' },
    { value: 'tacos-2', viewValue: 'Tacos' },
  ];
  selected = 'pizza-1';

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: Element): string {
    if (!row) {
      return '';
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.position + 1
    }`;
  }
}
